import React, { Fragment } from 'react';
import OrderDetailsUser from '../order-details-info/order-details-user';
import OrderDetailsDelivery from '../order-details-info/order-details-delivery';
import { OrderType } from 'models/order.model';
import OrderDetailsInfo from 'pages/order-details/order-details-info';
import OrderDetailsRider from '../order-details-info/order-details-rider';
import TrackOrder from 'components/base/track-order';

const KitchenOrderDetails = ({
  order,
  showChangeAddressModal,
  addressModal
}: {
  order: OrderType;
  showChangeAddressModal: boolean;
  addressModal: () => void;
}) => {
  return (
    <Fragment>
      <OrderDetailsUser order={order} />

      <div className='bg-[#F7F7F8] space-y-6 p-5'>
        <div className='grid min-h-[300px] lg:grid-cols-2 gap-4'>
          <OrderDetailsInfo order={order} />
          <OrderDetailsRider order={order} />
        </div>
        <div className='grid min-h-[300px] lg:grid-cols-3 gap-4'>
          <OrderDetailsDelivery
            order={order}
            show={showChangeAddressModal}
            addressModal={addressModal}
          />
          <div className='lg:col-span-2'>
            <TrackOrder order={order} />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default KitchenOrderDetails;
